var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const ACTIVE = 'active';
export class NGState {
    init(db, aid) {
        this._collection = db.collection('apps').doc(aid).collection('states');
        this._doc = this._collection.doc(ACTIVE);
    }
    update(value) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this._doc.update(value);
            }
            catch (e) {
                if (e.code === 'not-found') {
                    yield this._doc.set(value);
                }
                else {
                    throw e;
                }
            }
        });
    }
    reset(value) {
        return __awaiter(this, void 0, void 0, function* () {
            if (value) {
                yield this._doc.set(value);
            }
            else {
                yield this._doc.delete();
            }
        });
    }
    get() {
        return __awaiter(this, void 0, void 0, function* () {
            const doc = yield this._doc.get();
            if (!doc.exists) {
                return;
            }
            return doc.data();
        });
    }
    watch(callback) {
        return this._doc.onSnapshot(doc => {
            if (doc.exists) {
                callback(doc.data());
            }
            else {
                callback();
            }
        }, e => console.error('NGState.watch', e));
    }
}
//# sourceMappingURL=NGState.js.map